
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/prijs-skipas",
      function () {
        return require("private-next-pages/[region]/[resort]/prijs-skipas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/prijs-skipas"])
      });
    }
  